<style>
:root {
  --base-spacing-unit: 24px;
  --half-spacing-unit: calc(var(--base-spacing-unit) / 2);

  --color-alpha: #1772FF;
  --color-form-highlight: #495060;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.container {
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  background-color: white;
  padding: var(--base-spacing-unit);
}

.table {
  width: 100%;
}

.table-header {
  display: flex;
  width: 100%;

  .bank-header{
    flex: 1 1 50%;
  }
}

.table-row {
  display: flex;
  width: 100%;

  .bank-body {
    flex: 1 1 50%;
  }
}

.table-data,
.header__item {
  flex: 1 1 20%;
  text-align: center;
  border: 0.5px solid var(--color-form-highlight);
}

.header__item {
  text-transform: uppercase;
  line-height: 200%;
  font-weight: 500;
}

.page-break{
  margin-bottom: var(--base-spacing-unit);
}

.ivu-switch-large {
    width: 100px;
}

.ivu-switch-large.ivu-switch-checked:after {
    left: 75px;
}

</style>

<template>
  <Card>
    <p slot="title"> List Pending Dana</p>

    <Button v-show="isPendingRekening" :disabled="!bankAccountId" :loading="isPrintPaymentPending" icon="ios-printer-outline" type="success"
      slot="extra" size="small" @click="printPaymentPending()">
      <span v-if="!isPrintPaymentPending">Cetak Pending Dana by Rekening Bank </span>
      <span v-else>Sedang diproses.....</span>
    </Button>

    <Card style="margin-bottom: 12px;">
      <ButtonGroup>
          <Button type="primary" size="large" @click="changePendingType('pending')">
              <Icon type="ios-arrow-back"></Icon>
              Mutasi Per Rekening
          </Button>
          <Button type="primary" size="large" @click="changePendingType('pendingAll')" v-if="user.role == 'SUPERVISOR' || user.role == 'ADMINISTRATOR' || user.role == 'SUPERVISOR-SBY'">
              All Mutasi
              <Icon type="ios-arrow-forward"></Icon>
          </Button>
      </ButtonGroup>
      <Button
          v-if="isPendingRekening"
          type="primary"
          :loading="loadingSearch"
          @click="getPaymentPendingByFilter"
          icon="ios-search"
          style="float: right;">
              <span v-if="!loadingSearch">Cari</span>
              <span v-else>Wait.....</span>
      </Button>
    </Card>

    <Card style="margin: 12px 0;">
      <Row type="flex" justify="space-between" style="margin-bottom: 12px;">
          <Col span="8">
              <transition name="move-right">
                <div v-if="isPendingRekening">
                  <Select
                      v-model="bankAccountId"
                      placeholder="Pilih Rekening Bank"
                      clearable
                      filterable>
                        <Option
                            v-for="bankAccount in bankAccounts"
                            :value="bankAccount.id"
                            :key="bankAccount.id">{{ bankAccount.accountName }}</Option>
                  </Select>
                </div>
              </transition>
              <transition name="move-right">
                <div v-if="isAllPendingRekening">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Tgl. Mutasi</Button>
                      <Date-picker
                          v-model="pendingDateSelected"
                          style="width: 100%;"
                          type="daterange"
                          transfer
                          format="yyyy-MM-dd"
                          @on-change="getAllPendingData()">
                      </Date-picker>
                  </ButtonGroup>
                </div>
              </transition>
          </Col>
          <Col span="4" style="padding-top: 0.25rem;">
              <i-switch v-if="(isPendingRekening)" size="large" v-model="isPendingDeletedFilter" @on-change="filterDeletedList">
                  <span slot="open">Deleted</span>
                  <span slot="close">Not Deleted</span>
              </i-switch>
              <i-switch v-if="(isAllPendingRekening)" size="large" v-model="isAllPendingDeletedFilter" @on-change="filterDeletedList">
                  <span slot="open">Deleted</span>
                  <span slot="close">Not Deleted</span>
              </i-switch>
          </Col>
          <Col span="11">
              <Spin size="large" v-show="loadingSearch"></Spin>
          </Col>
      </Row>
      <Row type="flex" justify="space-between" style="margin-bottom: 12px;">
          <Col span="8">
              <transition name="move-right">
                <div v-show="isPendingRekening">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Cabang</Button>
                        <Select
                                v-model="searchSelectSubbranch"
                                placeholder="Branchcode"
                                >
                                <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                                    {{ subbranch.subbranchname }}
                                </Option>
                            </Select>
                  </ButtonGroup>
                </div>
              </transition>
          </Col>
      </Row>
      <Row type="flex" justify="space-between">
          <Col span="8">
              <transition name="move-right">
                <div v-show="isPendingRekening">
                  <ButtonGroup class="custom-group-parent">
                    <Button class="custom-group">Tgl. Mutasi</Button>
                    <Date-picker
                      v-model="pendingDateFilter"
                      style="width: 100%;"
                      type="daterange"
                      format="yyyy-MM-dd">
                    </Date-picker>
                  </ButtonGroup>
                </div>
              </transition>
          </Col>
          <Col span="8">
              <transition name="move-right">
                <div v-show="isPendingRekening">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Type</Button>
                        <Select
                            v-model="selectedType">
                              <Option
                                  v-for="type in ntTypes"
                                  :value="type.value"
                                  :key="type.value">{{ type.label }}</Option>
                        </Select>
                  </ButtonGroup>
                </div>
              </transition>
          </Col>
          <Col span="7">
              <transition name="move-right">
                <div v-show="isPendingRekening">
                  <ButtonGroup class="custom-group-parent">
                      <Button class="custom-group">Status</Button>
                        <Select
                            v-model="selectedStatus">
                              <Option
                                  v-for="status in mutationStatus"
                                  :value="status.value"
                                  :key="status.value">{{ status.label }}</Option>
                        </Select>
                  </ButtonGroup>
                </div>
              </transition>
          </Col>
      </Row>
    </Card>

    <Card v-if="paymentPending.length != 0" v-show="isPendingRekening">
        <button type="button" @click="generatePdfByRek" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate PDF</span></button>
        <button type="button" @click="generateExcelByRek" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
        <button type="button" @click="showFormNT" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Fix Kode NT</span></button>
        <br><br>
          <b v-if="isLoadingTotalMutasi"><Alert type="info" show-icon>Total Mutasi : {{ totalMutasiPerPending | currency }}</Alert></b>
          <b v-if="isLoadingTotalMutasi"><Alert type="info" show-icon>Total Mutasi Yang Belum Dibayarkan : {{ totalPendingPerPending | currency }}</Alert></b>
          <Spin v-else v-show="true"></Spin>
          <cPaymentPending
              :indexId="12"
              :headers="headerPending"
              :columns="columnPending"
              :pendings="paymentPending"
              :totalMutasi="totalMutasiPerPending"
              :type="isPer"
              @setHotGiroData="setHotGiroDataByRek"
          >
          </cPaymentPending>
      </Card>

      <Card v-if="paymentPendings.length != 0" v-show="isAllPendingRekening">
        <button type="button" @click="generatePdfAll" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate PDF</span></button>
        <button type="button" @click="generateExcelAll" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
        <br><br>
          <b><Alert type="info" show-icon>Total Mutasi : {{ totalMutasiAllPending | currency }}</Alert></b>
          <b><Alert type="info" show-icon>Total Mutasi Yang Belum Dibayarkan : {{ totalPendingAllPending | currency }}</Alert></b>
          <cPaymentPendingAll
              :indexId="12"
              :headers="headerPendings"
              :columns="columnPendings"
              :pendings="paymentPendings"
              :totalMutasi="totalMutasiAllPending"
              :type="isAll"
              @refreshPage="refreshPage"
              @setHotGiroData="setHotGiroDataAll"
          >
          </cPaymentPendingAll>
      </Card>

      <Card v-if="isNotFound">
            <Alert type="error">Data tidak ditemukan !</Alert>
      </Card>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="550"
      :filename= this.filename
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2PdfByRek"
      >
      <section slot="pdf-content">
        <div class="container">
          <div class="table">
            <div class="table-header">
              <div class="header__item">Tanggal Pembayaran</div>
              <div class="header__item">Admin</div>
              <div class="header__item">Tanggal Mutasi</div>
              <div class="header__item bank-header">Keterangan</div>
              <div class="header__item">Mutasi</div>
              <div class="header__item bank-header">Keterangan Pembayaran</div>
              <div class="header__item">Marking</div>
              <div class="header__item">Marking Group</div>
            </div>
            <div class="table-content">
              <section class="pdf-item" v-for="(value, index) in hotGiroDataByRek">
              <div class="table-row" :class="{ 'html2pdf__page-break page-break': (index + 1) % 12 === 0 }">
                <div class="table-data">{{ value.tanggalPembayaran }}</div>
                <div class="table-data">{{ value.admin }}</div>
                <div class="table-data">{{ value.tanggal }}</div>
                <div class="table-data bank-body">{{ value.keterangan }}</div>
                <div class="table-data">{{ value.mutasi }}</div>
                <div class="table-data bank-body">{{ value.keteranganPembayaran }}</div>
                <div class="table-data">{{ value.marking }}</div>
                <div class="table-data">{{ value.markingGroup }}</div>
              </div>

              <div class="table-header" v-if="(index + 1) % 12 === 0 && hotGiroDataByRek.length !== index+1">
                <div class="header__item">Tanggal Pembayaran</div>
                <div class="header__item">Admin</div>
                <div class="header__item">Tanggal Mutasi</div>
                <div class="header__item bank-header">Keterangan</div>
                <div class="header__item">Mutasi</div>
                <div class="header__item bank-header">Keterangan Pembayaran</div>
                <div class="header__item">Marking</div>
                <div class="header__item">Marking Group</div>
              </div>

              </section>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="550"
      :filename= this.filename
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2PdfAll"
      >
      <section slot="pdf-content">
        <div class="container">
          <div class="table">
            <div class="table-header">
              <div class="header__item">Tanggal Pembayaran</div>
              <div class="header__item">Admin</div>
              <div class="header__item">Tanggal Mutasi</div>
              <div class="header__item bank-header">Keterangan</div>
              <div class="header__item">Mutasi</div>
              <div class="header__item bank-header">Bank</div>
              <div class="header__item">Marking</div>
              <div class="header__item">Marking Group</div>
            </div>
            <div class="table-content">
              <section class="pdf-item" v-for="(value, index) in hotGiroDataAll">
                <div class="table-row" :class="{ 'html2pdf__page-break page-break': (index + 1) % 12 === 0 }">
                  <div class="table-data">{{ value.tanggalPembayaran }}</div>
                  <div class="table-data">{{ value.admin }}</div>
                  <div class="table-data">{{ value.tanggal }}</div>
                  <div class="table-data bank-body">{{ value.keterangan }}</div>
                  <div class="table-data">{{ value.mutasi }}</div>
                  <div class="table-data bank-body">{{ value.bank }}</div>
                  <div class="table-data">{{ value.marking }}</div>
                  <div class="table-data">{{ value.markingGroup }}</div>
                </div>

                <div class="table-header" v-if="(index + 1) % 12 === 0 && hotGiroDataAll.length !== index+1">
                  <div class="header__item">Tanggal Pembayaran</div>
                  <div class="header__item">Admin</div>
                  <div class="header__item">Tanggal Mutasi</div>
                  <div class="header__item bank-header">Keterangan</div>
                  <div class="header__item">Mutasi</div>
                  <div class="header__item bank-header">Bank</div>
                  <div class="header__item">Marking</div>
                  <div class="header__item">Marking Group</div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </Card>

</template>

<script>
  import {HTTP} from '@/components/http-lib'
  import cPaymentPending from '@/components/payment/cPaymentPending';
  import cPaymentPendingAll from '@/components/payment/cPaymentPendingAll';
  import _ from 'lodash'
  import moment from 'moment'
  import VueHtml2pdf from 'vue-html2pdf'
  import * as XLSX from 'xlsx'

  const numeral = require('numeral');


  export default {
    data: () => ({
        isPer: "per",
        isAll: "all",
        isPendingRekening: true,
        isAllPendingRekening: false,
        bankAccountId: null,
        showFormNote: false,
        searchSelectSubbranch: null,
        subbranchs: [],
        ntTypes: [
          {
              value: "ALL",
              label: 'Semua Data'
          },
          {
              value: "GIRO",
              label: 'Giro '
          },
          {
              value: "MUTASI",
              label: 'Mutasi'
          }
        ],
        selectedType : "ALL",
        mutationStatus: [
          {
              value: "A",
              label: 'Semua Data'
          },
          {
              value: "P",
              label: 'Sudah Pembayaran'
          },
          {
              value: "NP",
              label: 'Belum Pembayaran'
          }
        ],
        selectedStatus : "NP",
        pendingDateFilter: [],
        headerPending: [
          "Tgl. Pembayaran",
          "Admin",
          "Tgl. Mutasi",
          "Keterangan",
          "Mutasi",
          "Keterangan Pembayaran",
          "Kode Note",
          "Marking",
          "Marking Group",
          "Ref. Giro NT",
          "Payment",
          "Action",
          "ID"
        ],
        headerPendings: [
          "Tgl. Pembayaran",
          "Admin",
          "Tgl. Mutasi",
          "Keterangan",
          "Mutasi",
          "Bank",
          "Kode Note",
          "Marking",
          "Marking Group",
          "Ref. Giro NT",
          "Payment",
          "Action",
          "ID",
          "isDeleted",
          "giro"
        ],
        formNT : {
          noteCode: "",
          noteCodeOld: ""
        },
        columnPending : [],
        columnPendings : [],
        paymentPending: [],
        paymentPendings: [],
        bankAccounts: [],
        pendingGroupedHeader: [],
        hotGiroDataByRek: [],
        hotGiroDataAll: [],
        pendingDate: "",
        pendingDateSelected: [],
        loadingSearch: false,
        isNotFound: false,
        totalMutasiPerPending: "0",
        totalPendingPerPending: "0",
        totalMutasiAllPending: "0",
        totalPendingAllPending: "0",
        userRole : localStorage.getItem('user.role'),
        user : {
            username : '',
            role : ''
        },
        isLoadingTotalMutasi: false,
        isPendingDeletedFilter: false,
        isAllPendingDeletedFilter: false,
        filename: "pending-dana-" + Date.now(),
        isPrintPaymentPending: false,
    }),
    methods: {
      changePendingType: function(type){
        this.isNotFound = false;

        console.log(this.userRole);

        if (type == "pending") {
            this.isPendingRekening = true;
            this.isAllPendingRekening = false;
        } else {
            this.isPendingRekening = false;
            this.isAllPendingRekening = true;
        }
      },
      getPeriode: function(i){
        if(this.pendingGroupedHeader[i] == true){
            // this.getPaymentPendingByFilter(this.bankAccounts[i], i);
        }
      },
      getPaymentPendingByFilter: function(bankAccountParam){
          console.log('perPending', this.pendingDateFilter);

          // if (bankAccountParam && bankAccountParam != "-") {
          //     this.bankAccountId = parseInt(bankAccountParam)
          // }

          if (this.bankAccountId == null) {
              return
          }

          let startDate = null;
          let endDate = null;

          if(this.pendingDateFilter[0] != "" && this.pendingDateFilter[0] != null) {
              startDate = moment(this.pendingDateFilter[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
              endDate = moment(this.pendingDateFilter[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          // set columns
          this.columnPending = [
            {
              data: "tanggalPembayaran",
              type: "date",
              dateFormat: 'DD/MM/YYYY',
              correctFormat: true,
              readOnly: true,
            },
            {
              data: "admin",
              type: "text",
              allowEmpty: false,
              readOnly: true,
            },
            {
              data: "tanggal",
              type: "date",
              dateFormat: 'DD/MM/YYYY',
              correctFormat: true,
              // readOnly: true,
            },
            {
              data: "keterangan",
              type: "text",
              allowEmpty: false,
              // readOnly: true,
            },
            {
              data: "mutasi",
              type: "numeric",
              numericFormat: {
                pattern: "0,0",
              },
              // readOnly: true,
            },
            {
              data: "keteranganPembayaran",
              type: "text",
              allowEmpty: false,
              readOnly: true,
            },
            // {
            //   data: "noteCode",
            //   type: "text",
            //   readOnly: true,
            // },
          ]

          let urlFindByFilter = 'paymentPending/findByFilter';
          this.paymentPending = []
          this.loadingSearch = true;

          HTTP
          .post(urlFindByFilter, {
            bankAccountId : this.bankAccountId,
            isDeleted : this.isPendingDeletedFilter,
            branchcode : this.searchSelectSubbranch,
            startDate: startDate,
            endDate: endDate,
            status: this.selectedStatus,
            ntType: this.selectedType,
          })
          .then(response => {
              console.log({response});
              let parent = this;
              _.forEach(response.data, function(value) {
                  let markingheadercode = ""
                  let markinggroup = ""
                  let isGiro = false

                  // if(value.payment){
                  //     markingheadercode = value.payment.marking_header.markingheadercode
                  // }

                  if (value.marking_header) {
                    markingheadercode = value.marking_header.markingheadercode;
                  }

                  if (value.marking_group) {
                    markinggroup = value.marking_group.code;
                  }

                  if (value.giro) {
                    isGiro = true;
                  }

                  let keteranganPembayaran = ""
                  let admin = null

                  if (value.payment) {
                    let tempKPArray = [] // handle data is not duplicate variable

                    _.forEach(value.payment, function(payment) {

                      if (!admin) {
                        admin = payment.createdby
                      }

                      _.forEach(payment.payment_allocate, function(payment_allocate) {
                        let description = payment_allocate.invoice_due_detail.receivable_detail.description;
                        let regex = /P-\d+/; // get string yg mengandung karakter "P-" lalu diikuti satu atau lebih angka (0-9) setelahnya
                        let partai = description.match(regex);
                        partai = partai ? partai[0] : ""; // handle null
                        let tempData = payment.marking_header.markingheadercode + ' - ' + partai;

                        if (tempKPArray.includes(tempData) == false) {
                          keteranganPembayaran += payment.marking_header.markingheadercode + ' - '; // set marking
                          keteranganPembayaran += partai + '\n';  //+ ' - '; // set partai
                          // keteranganPembayaran += 'Rp. ' + payment_allocate.allocateAmount + '\n'; // set nominal & new line
                        }

                        tempKPArray.push(tempData); // handle data is not duplicate
                      })
                    })
                  }
                  let mutasi = value.amount

                  console.log(value);


                  let pending = {
                      id : value.id,
                      tanggal : moment(value.transactionDate, 'YYYY-MM-DD').format("DD/MM/YYYY"),
                      admin : admin,
                      keterangan : value.notes,
                      saldo : value.balance,
                      cabang : value.branch,
                      mutasi : mutasi,
                      markingHeaderId : value.markingHeaderId,
                      markingGroupId : value.markingGroupId,
                      marking : markingheadercode,
                      markingGroup : markinggroup,
                      createdby : value.createdby,
                      transactionDate : value.transactionDate,
                      payment : value.payment,
                      bank: value.bank_account.accountName,
                      giro: isGiro,
                      isDeleted: value.isDeleted,
                      tanggalPembayaran: value.paymentDate ? moment(value.paymentDate, 'YYYY-MM-DD hh:mm:ss').format("DD/MM/YYYY") : null,
                      keteranganPembayaran: keteranganPembayaran,
                      color: value.colour,
                      bankAccountId: parent.bankAccountId,
                      startEndDate: null,
                      isPayment: value.isPayment,
                      noteCode: value.noteCode,
                      ntType: value.ntType,
                      refGiro: value.refGiroCode,
                      isDeposit: value.isDeposit
                  }

                  console.log(pending);

                  parent.paymentPending.push(pending);
              });

              this.getTotalMutasi('perPending')
              this.loadingSearch = false;
          })
          .catch(e => {
              this.loadingSearch = false;
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          })
      },
      getAllPendingData: function(startEndDateParam){
          console.log('allPending');

          if (startEndDateParam && startEndDateParam != "-") {
              let splitParam = startEndDateParam.split('|')

              this.pendingDateSelected[0] = splitParam[0]
              this.pendingDateSelected[1] = splitParam[1]
          }

          if(this.pendingDateSelected[0] == ''){
              return;
          }

          let startDate = null;
          let endDate = null;

          if(this.pendingDateSelected[0] != "" && this.pendingDateSelected[0] != null) {
              startDate = moment(this.pendingDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
              endDate = moment(this.pendingDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          // set columns
          this.columnPendings = [
            {
              data: "tanggalPembayaran",
              type: "date",
              dateFormat: 'DD/MM/YYYY',
              correctFormat: true,
              readOnly: true,
            },
            {
              data: "admin",
              type: "text",
              allowEmpty: false,
              readOnly: true,
            },
            {
              data: "tanggal",
              type: "date",
              dateFormat: 'DD/MM/YYYY',
              correctFormat: true,
              readOnly: true,
            },
            {
              data: "keterangan",
              type: "text",
              allowEmpty: false,
              readOnly: true,
            },
            { data: "mutasi",
              type: "numeric",
              numericFormat: {
                pattern: "0,0",
              },
              readOnly: true,
            },
            { data: "bank",
              type: "text",
              allowEmpty: false,
              readOnly: true,
            },
            {
              data: "noteCode",
              type: "text",
              readOnly: true,
            },
          ]

          let urlFindByFilter = 'paymentPending/findByFilter';
          this.paymentPendings = []
          this.loadingSearch = true;

          HTTP
          .post(urlFindByFilter, {
            startDate: startDate,
            endDate: endDate,
            isDeleted : this.isAllPendingDeletedFilter,
            status : null
          })
          .then(response => {
              console.log({response});
              let parent = this;
              _.forEach(response.data, function(value) {
                  let markingheadercode = ""
                  let markinggroup = ""
                  let isGiro = false
                  let admin = null

                  // if(value.payment){
                  //     markingheadercode = value.payment.marking_header.markingheadercode
                  // }

                  if (value.marking_header) {
                    markingheadercode = value.marking_header.markingheadercode;
                  }

                  if (value.marking_group) {
                    markinggroup = value.marking_group.code;
                  }

                  if (value.giro) {
                    isGiro = true;
                  }

                  _.forEach(value.payment, payment => {
                    if(!admin) {
                      admin = payment.createdby
                    }
                  })

                  let paymentPending = {
                      id : value.id,
                      tanggal : value.transactionDate,
                      admin : admin,
                      keterangan : value.notes,
                      saldo : value.balance,
                      cabang : value.branch,
                      mutasi : value.amount,
                      markingHeaderId : value.markingHeaderId,
                      markingGroupId : value.markingGroupId,
                      marking : markingheadercode,
                      markingGroup : markinggroup,
                      createdby : value.createdby,
                      transactionDate : value.transactionDate,
                      payment : value.payment,
                      bank: value.bank_account.accountName,
                      giro: isGiro,
                      isDeleted: value.isDeleted,
                      notesDeleted: value.notesDeleted,
                      tanggalPembayaran: value.paymentDate ? moment(value.paymentDate, 'YYYY-MM-DD hh:mm:ss').format("DD/MM/YYYY") : null,
                      color: value.colour,
                      bankAccountId: null,
                      startEndDate: startDate + '|' + endDate,
                      isPayment: value.isPayment,
                      noteCode : value.noteCode,
                      isDeposit : value.isDeposit,
                  }
                  parent.paymentPendings.push(paymentPending);
              });

              this.getTotalMutasi('allPending');
              this.loadingSearch = false;
          })
          .catch(e => {
              this.loadingSearch = false;
              this.$Notice.error({
                  title: "Error",
                  desc: e,
                  duration: 5
              });
          })
      },
      getBankAccount: function() {
        HTTP.get("bankAccount/findAll/active")
          .then(response => {
            this.bankAccounts = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
      },
      getPendingList: function(){
          if(this.summaryDate !== '' || this.bankAccountId){
              return HTTP.post('paymentPending/getTotalSummary', {
                  transactionDate: this.pendingDate,
                  bankAccountId: this.bankAccountId,
                  startDate: this.startDate,
                  endDate: this.endDate,
              })
          } else {
              this.summaryAllMarkings = []
          }
      },
      getTotalMutasi: function(type){
        // this.totalMutasiPerPending = 0;
        // this.totalMutasiAllPending = 0;
        this.pendingDate = moment(this.pendingDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
        let startDate = null;
        let endDate = null;
        let payload = {}

        if (type === 'perPending') {
          if(this.pendingDateFilter[0] != "" && this.pendingDateFilter[0] != null) {
              startDate = moment(this.pendingDateFilter[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
              endDate = moment(this.pendingDateFilter[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          payload = {
            bankAccountId : this.bankAccountId,
            isDeleted : this.isPendingDeletedFilter,
            startDate: startDate,
            endDate: endDate,
            status: this.selectedStatus,
          }
        } else if (type === 'allPending') {
          if(this.pendingDateSelected[0] != "" && this.pendingDateSelected[0] != null) {
                startDate = moment(this.pendingDateSelected[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                endDate = moment(this.pendingDateSelected[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
          }

          payload = {
            startDate: startDate,
            endDate: endDate,
            isDeleted : this.isAllPendingDeletedFilter
          }
        }

        this.isLoadingTotalMutasi = false

        HTTP
        .post('paymentPending/getTotalSummary', payload)
        .then(response => {
            console.log({response});
            if (type === 'perPending') {
              this.totalMutasiPerPending = response.data.total_mutations;
              this.totalPendingPerPending = response.data.total_pendings;

              if(this.paymentPending.length == 0) {
                this.isNotFound = true
              } else {
                this.isNotFound = false
                // add total mutasi on last row
                this.paymentPending.push({
                  mutasi : response.data.total_mutations,
                });
              }

            } else if (type === 'allPending') {
              this.totalMutasiAllPending = response.data.total_mutations;
              this.totalPendingAllPending = response.data.total_pendings;

              if(this.paymentPendings.length == 0) {
                this.isNotFound = true
              } else {
                this.isNotFound = false
                // add total mutasi on last row
                this.paymentPendings.push({
                  mutasi : response.data.total_mutations,
                });
              }
            }

            this.isLoadingTotalMutasi = true
        })
        .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
        });
      },
      filterDeletedList: function() {
        if (this.isPendingRekening) {
          this.getPaymentPendingByFilter()
        } else {
          this.getAllPendingData()
        }
      },
      refreshPage : function(){
        this.getPaymentPendingByFilter()
        this.getAllPendingData()
      },
      setHotGiroDataByRek(hotGiroData) {
          const arrayGiroData = []
         // paymentDate giroNumber giroNominal accountName dueDate
          hotGiroData.forEach(value => {
            let girodata = {
              tanggalPembayaran: value[0],
              admin: value[1],
              tanggal: value[2],
              keterangan: value[3],
              mutasi: value[4],
              keteranganPembayaran: value[5],
              marking: value[6],
              markingGroup: value[7],
            }
            arrayGiroData.push(girodata)
          })
          this.hotGiroDataByRek = arrayGiroData
      },
      setHotGiroDataAll(hotGiroData) {
        const arrayGiroData = []
        // paymentDate giroNumber giroNominal accountName dueDate
        hotGiroData.forEach(value => {
          let girodata = {
            tanggalPembayaran: value[0],
            admin: value[1],
            tanggal: value[2],
            keterangan: value[3],
            mutasi: value[4],
            bank: value[5],
            marking: value[6],
            markingGroup: value[7],
          }
          arrayGiroData.push(girodata)
        })
        this.hotGiroDataAll = arrayGiroData
      },
      generatePdfByRek () {
        this.$refs.html2PdfByRek.generatePdf()
      },
      generatePdfAll () {
        this.$refs.html2PdfAll.generatePdf()
      },
      generateExcelByRek () {
        const data = XLSX.utils.json_to_sheet(this.hotGiroDataByRek);

        data['!cols'] = [
          { width: 20 },
          { width: 20 },
          { width: 20 },
          { width: 70 },
          { width: 20 },
          { width: 70 },
          { width: 20 },
          { width: 20 },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.sheet_add_aoa(data, [['Tanggal Pembayaran', 'Admin', 'Tanggal', 'Keterangan', 'Mutasi', 'Keteragan Pembayaran', 'Marking', 'Marking Group']])
        XLSX.utils.book_append_sheet(wb, data, 'Pending dana');
        XLSX.writeFile(wb, this.filename + '.xlsx');

      },
      showFormNT () {
        this.showFormNote = true;
      },
      generateExcelAll : function() {
          const data = XLSX.utils.json_to_sheet(this.hotGiroDataAll)

          data['!cols'] = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 70 },
            { width: 20 },
            { width: 70 },
            { width: 20 },
            { width: 20 },
          ];
          const wb = XLSX.utils.book_new()
          XLSX.utils.sheet_add_aoa(data, [['Tanggal Pembayaran', 'Admin', 'Tanggal', 'Keterangan', 'Mutasi', 'Bank', 'Marking', 'Marking Group']])
          XLSX.utils.book_append_sheet(wb, data, 'Pending dana')
          XLSX.writeFile(wb, this.filename + '.xlsx')
      },
      printPaymentPending () {
        const bankAccountId = this.bankAccountId
        const selected = this.bankAccounts.find(acc => acc.id === bankAccountId)
        const accountName = selected ? selected.accountName : null

        this.isPrintPaymentPending = true
        HTTP.post('paymentPending/print-to-excel', { bankAccountId }, {
          responseType: 'blob'
        })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `MUTASI - ${accountName} - ${moment(new Date()).format("DDMMYY")}.xls`); // name file downloaded
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.isPrintPaymentPending = false;
          })
      },
      getSubbranch: function(){
            HTTP
            .get('subbranch')
            .then(response => {
                this.subbranchs = response.data
            })
            .catch(e => {
                //console.log(e);
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
    },
    components: {
      cPaymentPending,
      cPaymentPendingAll,
      VueHtml2pdf
    },
    filters: {
      currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
      }
    },
    mounted() {
      this.getBankAccount();

      let uriType = this.$route.params.type;
      let data = this.$route.params.data;

      // per = bankAccountId, all = startDate & endDate

      if (uriType == "all") {
        this.isPendingRekening = false
        this.isAllPendingRekening = true
        this.getAllPendingData(data);
      } else {
        this.isPendingRekening = true
        this.isAllPendingRekening = false
        this.getPaymentPendingByFilter(data);
      }

      console.log('✅ mounted:', this.$route.fullPath)
    },
    created() {
      this.getSubbranch();
      this.user.username = localStorage.getItem('user.username')
      this.user.role = localStorage.getItem('user.role')
    }
}
</script>




// WEBPACK FOOTER //
// PaymentPendingListData.vue?54ebc7bd